"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStopDictate;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStopDictate() {
  return (0, _useWebChatAPIContext.default)().stopDictate;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTdG9wRGljdGF0ZSIsInVzZVdlYkNoYXRBUElDb250ZXh0Iiwic3RvcERpY3RhdGUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTdG9wRGljdGF0ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVN0b3BEaWN0YXRlKCk6ICgpID0+IHZvaWQge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5zdG9wRGljdGF0ZTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRWUsU0FBU0EsY0FBVCxHQUFzQztFQUNuRCxPQUFPLElBQUFDLDZCQUFBLElBQXVCQyxXQUE5QjtBQUNEIn0=